import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { ALL_PAYMENT_STATUSES } from '../../constants/payments';

import {
  Table,
  Header,
  Row,
  HeaderCell,
  Cell,
  Body,
  HeaderText,
  CellText,
  Icon,
  ToolTip,
  ContainerRating,
  TextHideTester,
  ContainerHideTester,
  LinkButton,
  ContainerId,
  ContainerPayment,
  ContainerFeedback,
  ClampLines,
  RedirectToVideoLink,
} from './styles';

import RatingStars from '../rating-stars';

const CompletedTestsSegment = (props) => {
  const {
    testSessions,
    onHide,
    onChangePaymentStatus,
    onClickResetRatingAndReview,
    onClickWritefeedback,
    isAdmin,
  } = props;

  return (
    <Table basic="very">
      <Header>
        <Row>
          {onHide && (
            <>
              <HeaderCell>
                <HeaderText>
                  Workspace
                </HeaderText>
              </HeaderCell>
              <HeaderCell>
                <HeaderText>
                  Project
                </HeaderText>
              </HeaderCell>
            </>
          )}
          <HeaderCell>
            <HeaderText>
              Completed on
            </HeaderText>
          </HeaderCell>
          <HeaderCell>
            <HeaderText>
              Test #
            </HeaderText>
          </HeaderCell>
          <HeaderCell>
            <HeaderText>
              Payment
              <ToolTip
                content={`Payment is sent to your PayPal address 7 days to the minute of when you uploaded the study.
                 To change your PayPal email address, go to “My Profile”. `}
                trigger={<Icon name="info circle" />}
              />
            </HeaderText>
          </HeaderCell>
          <HeaderCell>
            <HeaderText>
              Status
              <ToolTip
                content={`Your payment will arrive in your Paypal account in 7 days.
                 If payment hasn’t arrived within 10 days, please contact us.`}
                trigger={<Icon name="info circle" />}
              />
            </HeaderText>
          </HeaderCell>
          <HeaderCell>
            <HeaderText>
              Rating
              <ToolTip
                content={`Companies rate video sessions and provide feedback to ensure quality.
                 The higher your rating, the more tests you’ll receive.`}
                trigger={<Icon name="info circle" />}
              />
            </HeaderText>
          </HeaderCell>

          {onHide && (
            <HeaderCell>
              <HeaderText>
                Tester View
              </HeaderText>
            </HeaderCell>
          )}

        </Row>
      </Header>

      <Body>
        {testSessions.map((testSession) => {
          const { tester: { testerPayment = {} } = {} } = testSession;

          // eslint-disable-next-line max-len
          const showChangePaymentStatus = onChangePaymentStatus && (testerPayment?.status === 'payment_pending' || testerPayment?.status === 'test_rejected');
          // eslint-disable-next-line max-len
          const showRedirectToVideoLink = isAdmin && (testSession?.tester?.project?.testType === 'unmoderated' || testSession?.tester?.project?.testType === 'moderated');
          return (
            <Row>
              {onHide && (
                <>
                  <Cell>
                    <CellText>
                      {testSession.tester.project.company.name}
                    </CellText>
                  </Cell>
                  <Cell>
                    <CellText>
                      {
                        showRedirectToVideoLink
                          ? (
                            <RedirectToVideoLink
                              // eslint-disable-next-line max-len
                              onClick={() => window.open(`/projects/${testSession?.tester?.project?.id}/videos/${testSession?.tester?.id}`, '_blank')}
                            >
                              {testSession?.tester?.project?.name}
                            </RedirectToVideoLink>
                          )

                          : testSession.tester.project.name
                      }
                    </CellText>
                  </Cell>
                </>
              )}
              <Cell>
                <CellText>
                  {testSession.completedAt && moment(testSession.completedAt).tz('America/New_York').format('MM/DD/YYYY hh:mm A')}
                </CellText>
              </Cell>
              <Cell>
                <CellText>
                  <ContainerId>
                    {testSession.tester.project.shareCode}
                  </ContainerId>
                </CellText>
              </Cell>
              <Cell>
                <CellText>
                  {testerPayment ? testerPayment.convertedAmount : '-'}
                </CellText>
              </Cell>
              <Cell>
                <CellText>
                  {testerPayment ? (
                    <ContainerPayment>
                      {ALL_PAYMENT_STATUSES[testerPayment.status]}
                      {showChangePaymentStatus && (
                        <LinkButton
                          onClick={() => onChangePaymentStatus(testerPayment)}
                        >
                          Change Status
                        </LinkButton>
                      )}
                    </ContainerPayment>
                  ) : '-'}
                </CellText>
              </Cell>
              <Cell>
                <CellText>
                  <ContainerRating>
                    {testSession.rating && (
                      <RatingStars rating={testSession.rating} />
                    )}
                    {testSession.ratingDescription && (
                      <ClampLines
                        text={testSession.ratingDescription}
                        lines={1}
                        ellipsis="..."
                        moreText="Show more"
                        lessText="Show less"
                        className="a"
                        innerElement="p"
                      />
                    )}
                    {_.isEmpty(testSession.ratingDescription) && (
                      <CellText>
                        Not Rated
                      </CellText>
                    )}

                    <ContainerFeedback>

                      {!_.isEmpty(testSession.feedback) && (
                        <>
                          <HeaderText>PlaybookUX feedback</HeaderText>
                          <ClampLines
                            text={testSession.feedback}
                            lines={1}
                            ellipsis="..."
                            moreText="Show more"
                            lessText="Show less"
                            className="a"
                            innerElement="p"
                          />
                        </>
                      )}

                      {onClickResetRatingAndReview && (testSession.rating || testSession.ratingDescription) && (
                        <LinkButton
                          onClick={() => onClickResetRatingAndReview(testSession.id)}
                        >
                          Reset rating & review
                        </LinkButton>
                      )}

                      {onClickWritefeedback && (
                        <LinkButton
                          onClick={() => onClickWritefeedback(testSession)}
                        >
                          Write feedback
                        </LinkButton>
                      )}

                    </ContainerFeedback>

                  </ContainerRating>
                </CellText>
              </Cell>

              {onHide && (
                <Cell>
                  <ContainerHideTester
                    onClick={() => onHide(testSession.tester.id)}
                  >
                    <TextHideTester>
                      {testSession.tester.hidden ? 'unhide' : 'hide'}
                    </TextHideTester>
                  </ContainerHideTester>
                </Cell>
              )}

            </Row>
          );
        })}
      </Body>
    </Table>
  );
};

CompletedTestsSegment.propTypes = {
  onHide: PropTypes.func,
  testSessions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    rating: PropTypes.number,
    ratingDescription: PropTypes.string,
    completedAt: PropTypes.string,
    testers: PropTypes.arrayOf(PropTypes.shape({
      project: PropTypes.shape({
        shareCode: PropTypes.string,
      }),
    })),
  })).isRequired,
  onChangePaymentStatus: PropTypes.func,
  onClickResetRatingAndReview: PropTypes.func,
  onClickWritefeedback: PropTypes.func,
  isAdmin: PropTypes.bool,
};

CompletedTestsSegment.defaultProps = {
  onHide: null,
  onChangePaymentStatus: null,
  onClickResetRatingAndReview: null,
  onClickWritefeedback: null,
  isAdmin: false,
};

export default CompletedTestsSegment;
